/**
 * 友達追加URL（組織エントリー）を組み立てる。
 * バックエンドの短縮パス `GET /e/:entryKey`（従来の `/line/entry/:entryKey` も有効のまま）。
 */
export function buildEntryUrl(entryKey: string): string {
  const base = (process.env.REACT_APP_API_BASE_URL ?? '').replace(/\/$/, '')
  return `${base}/e/${entryKey}`
}
